import * as formats from "../../../../common/formats";

require('select2');
require('tempusdominus-bootstrap-4');

var baseDatepickerOpts = {
    locale: 'ja',
    dayViewHeaderFormat: 'YYYY年 M月',
    format: 'YYYY/MM/DD',
};

// 新規契約作成
$(() => {
    if (document.getElementById('agent-company-receipt') != null) {
        $('.date .datepicker').datetimepicker(baseDatepickerOpts);
        setupMonthlyDatepicker();
        setUpReset();
        // addMonthlyLimit();
    }
});

// 月別条件datepicker構築
function setupMonthlyDatepicker() {
    var monthOpts = {
        ...baseDatepickerOpts,
        viewMode: 'years',
        format: 'YYYY/MM',
    };
    $('.month .datepicker').datetimepicker(monthOpts);
    $('.datepicker').blur(function() {
        $('#' + this.id).datetimepicker('hide');
        console.log(this.id);
        if ((this.id !== 'add_business_report') && ((this.id !== 'add_invoice_limit'))) {
            $('#form').append('<input name="edit[' + this.id + ']" type="hidden" value="'+ this.value +'" />');
        }
    });
}

// 月別指定の追加　
// function addMonthlyLimit() {
//     $(document).on('click', 'js-add-limit', function(e) {
//
//     });
// }


function setUpReset() {
    $(document).on("click", '.js-reset-limit', function(e) {
        $.ajax({
            url: '/agent/company/receipt_default',
            type: 'POST',
            data: { id: this.id },
            dataType: 'json',
            timespan: 1000,
            context: this
        }).done(function(data, textStatus, jqXHR) {
            $('#business_report_'+ this.id).val(data.business_report_limit);
            $('#invoice_limit_'+ this.id).val(data.invoice_limit);
            $('#form').append('<input name="edit[business_report_' + this.id + ']" type="hidden" value="delete" />');
            $('#form').append('<input name="edit[invoice_limit_' + this.id + ']" type="hidden" value="delete" />');

            $('#' + this.id).remove();
        }).fail(function(jqXHR, textStatus, errorThrown ) {
        }).always(function() {
        });
    });
}

